import { Pipe, PipeTransform } from '@angular/core';
import { TinyHelpers } from '@coin/shared/core/util-helpers';

@Pipe({
  name: 'pascalCaseToKebabCase',
  standalone: true
})
export class PascalCaseToKebabCasePipe implements PipeTransform {
  transform(value: string): string {
    return TinyHelpers.pascalcaseToKebabCase(value);
  }
}
